import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Localized } from '../../../objects';

@Injectable()
export class LiturgyTypeService {

  private cache: LiturgyType[];

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<LiturgyType[]> {

    const p = new Promise<LiturgyType[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("LiturgyType cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/LiturgyType/", null).subscribe(
        (data: LiturgyType[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;
}

}


export class LiturgyType {
  Id: number;
  ReligionBranch: any;
  DisplayOrder: number;

  Localized: Localized[];
}
